import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Divider from "@material-ui/core/Divider";
import Button from "@material-ui/core/Button";
import { Link } from "react-router-dom";
import SimpleDialogDemo from "../../Modals/SimpleDialog";
import BusinessCreate from "./BusinessCreate";

export default function BusinessListContainer(props) {
  const { subEventIndex, subEvent } = props;
  const dispatch = useDispatch();
  const userID = useSelector((state) => state.atlete.userID);
  const atleteAccount = useSelector((state) => state.atlete.atleteAccount);
  const [business, setBusiness] = useState(false);

  useEffect(() => {
    if (atleteAccount && atleteAccount.businessAuth) {
      setBusiness(
        Object.values(atleteAccount.businessAuth).filter(
          (a) => a.profile !== "noauth"
        )[0]
      );
    }
  }, [atleteAccount]);

  const businessList =
    atleteAccount && atleteAccount.businessAuth
      ? Object.values(atleteAccount.businessAuth)
        .filter((a) => a.profile !== "noauth")
        .sort((a, b) => a.name.localeCompare(b.name))
      : [];

  return (
    <Grid container spacing={3} alignItems="flex-start">
      <Grid item xs={12}>
        <Typography gutterBottom variant="h4" component="h4">
          Configuración de Empresas
        </Typography>
      </Grid>

      {atleteAccount && atleteAccount.perfil === 1 && (
        <Grid item xs={12}>
          <SimpleDialogDemo buttonText={"Crear una Empresa"}>
            <BusinessCreate />
          </SimpleDialogDemo>
        </Grid>
      )}

      {atleteAccount && businessList.length > 0 && (
        <Grid item xs={12}>
          <Grid container alignItems="center" spacing={2}>
            <Grid item xs={12} sm={7}>
              <Typography
                variant="subtitle1"
                style={{ fontWeight: 600 }}
              >
                Nombre
              </Typography>
            </Grid>

            <Grid item xs={12} sm={3}>
              <Typography
                variant="body2"
                style={{ color: "#666", wordBreak: "break-word" }}
              >
                Id del negocio
              </Typography>
            </Grid>

            <Grid
              item
              xs={12}
              sm={2}
              style={{ textAlign: "right" }}
            >
              <Typography
                variant="body2"
                style={{ color: "#1976d2", fontWeight: 500 }}
              >

              </Typography>
            </Grid>
          </Grid>

          <Paper elevation={2} style={{ overflow: "hidden" }}>
            {businessList.map((i, index) => (
              <React.Fragment key={i.businessId}>
                <Link
                  to={`/${i.businessId}/inicio/`}
                  style={{
                    textDecoration: "none",
                    color: "inherit",
                    display: "block",
                  }}
                >
                  <div
                    style={{
                      padding: "16px 20px",
                      cursor: "pointer",
                      transition: "background 0.2s ease",
                    }}
                  >
                    <Grid container alignItems="center" spacing={2}>
                      <Grid item xs={12} sm={7}>
                        <Typography
                          variant="subtitle1"
                          style={{ fontWeight: 600 }}
                        >
                          {i.name}
                        </Typography>
                      </Grid>

                      <Grid item xs={12} sm={3}>
                        <Typography
                          variant="body2"
                          style={{ color: "#666", wordBreak: "break-word" }}
                        >
                          {i.businessId}
                        </Typography>
                      </Grid>

                      <Grid
                        item
                        xs={12}
                        sm={2}
                        style={{ textAlign: "right" }}
                      >
                        <Typography
                          variant="body2"
                          style={{ color: "#1976d2", fontWeight: 500 }}
                        >
                          Ver negocio
                        </Typography>
                      </Grid>
                    </Grid>
                  </div>
                </Link>

                {index < businessList.length - 1 && <Divider />}
              </React.Fragment>
            ))}
          </Paper>
        </Grid>
      )}
    </Grid>
  );
}